var chunkMapping = {
	"6179": [
		62797,
		75228,
		88296,
		93947
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		91840
	],
	"7293": [
		"default",
		"./AppLoader",
		91840
	],
	"17418": [
		"default",
		"./appSlice",
		91840
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		91840
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		91840
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		91840
	],
	"49394": [
		"default",
		"./store",
		91840
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		91840
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		91840
	],
	"75228": [
		"default",
		"./utils/constants",
		91840
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		91840
	],
	"85646": [
		"default",
		"./headerSlice",
		91840
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		91840
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		91840
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		91840
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 91840
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}